if (!customElements.get('tm-titre-cta-expand')) {
  customElements.define(
    'tm-titre-cta-expand',
    class TmTitreCtaExpand extends HTMLElement {
      connectedCallback() {
        this.body = this.querySelector('[data-expand-body]');
        this.button = this.querySelector('[data-expand-toggle]');
        if (!this.body || !this.button) return;

        this.button.addEventListener('click', () => this.toggle());

        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.body);
        this.update();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      isExpanded() {
        return this.classList.contains('is-expanded');
      }

      update() {
        if (this.isExpanded()) {
          this.classList.remove('is-truncated');
          this.button.hidden = false;
          return;
        }

        const overflowing = this.body.scrollHeight > this.body.clientHeight + 1;
        this.classList.toggle('is-truncated', overflowing);
        this.button.hidden = !overflowing;
      }

      toggle() {
        const expanded = !this.isExpanded();
        this.classList.toggle('is-expanded', expanded);
        this.button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        this.update();
      }
    }
  );
}
